<template>
  <div>
    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :server-items-length="table.total"
        @update:options="updateTable"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [5, 10, 15]
        }"
        class="elevation-1">
        <template v-slot:top>
          <div class="px-3">
            <v-row>
              <v-col md="3">
                <v-select
                  item-text="name"
                  item-value="_id"
                  :items="banks.data"
                  :disabled="isEmpty(banks.data)"
                  v-model.lazy="bank"
                  :label="$t('expenses.bankReconciliation.transactions.bank')"
                  @change="handleBankChange()"
                  rounded
                  outlined
                  dense
                />
              </v-col>
              <!-- <v-col md="3">
                <v-select
                  item-text="name"
                  item-value="id"
                  :items="accounts.data"
                  :disabled="isEmpty(accounts.data)"
                  v-model.lazy="account"
                  :label="$t('expenses.bankReconciliation.transactions.account')"
                  @change="handleAccountChange()"
                  rounded
                  outlined
                  dense
                />
              </v-col> -->
              <v-col md="3">
                <v-menu
                  ref="datePicker"
                  v-model="datePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="range"
                      label="Rango de fechas"
                      prepend-icon="mdi-calendar"
                      outlined
                      rounded
                      readonly
                      hide-details
                      dense
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    :range="true"
                    first-day-of-week="1"
                    :allowed-dates="allowedDates"
                    no-title
                  >
                    <div>
                      <div class="d-flex">
                        <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                        <v-spacer/>
                        <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                        <v-btn :disabled="dates.length < 2" color="primary" @click="loadBankTransactions()">OK</v-btn>
                      </div>
                    </div>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <div>
            {{ $moment(item.date).format('DD/MM/YYYY') }}
          </div>
        </template>
        <template v-slot:[`item.description`]="{ item }">
          <div>
            {{ item.description }}
          </div>
        </template>
        <template v-slot:[`item.charge`]="{ item }">
          <div v-if="item.isCharge === 'true'">
            ${{ item.amount | toFix2 | numberWithComma }} {{ item.currency }}
          </div>
          <div v-else> - </div>
        </template>
        <template v-slot:[`item.deposit`]="{ item }">
          <div v-if="item.isCharge === 'false'">
            ${{ item.amount | toFix2 | numberWithComma }} {{ item.currency }}
          </div>
          <div v-else> - </div>
        </template>
        <template v-slot:[`item.balance`]="{ item }">
          <div v-if="item.balance">
            ${{ item.balance | toFix2 | numberWithComma }} {{ item.currency }}
          </div>
          <div v-else> - </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  name: 'Movements',
  data () {
    return {
      overlay: false,
      section: this.$i18n.t('expenses.registerMovements.section'),
      table: {
        title: this.$i18n.t('expenses.bankReconciliation.transactions.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.date'), value: 'date', sortable: true, align: 'center' },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.description'), value: 'description', sortable: false, align: 'center' },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.charge'), value: 'charge', sortable: false, align: 'center' },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.deposit'), value: 'deposit', sortable: false, align: 'center' },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.balance'), value: 'balance', sortable: false, align: 'center' }
        ],
        data: [],
        total: 0,
        selected: [],
        options: {
          itemsPerPage: 10,
          page: 1
        }
      },
      banks: {
        loading: false,
        data: []
      },
      bank: null,
      accounts: {
        data: [],
        loading: false
      },
      account: null,
      datePicker: false,
      dates: []
    }
  },
  async mounted () {
    await this.loadBanks()
  },
  computed: {
    range () {
      const dates = this.dates
      return dates.length < 2 ? '' : `${dates[0]} / ${dates[1]}`
    }
  },
  watch: {
    '$store.state.currentRestaurant.data': async function (val) {
      this.resetForm()
      await this.loadBanks()
    }
  },
  methods: {
    isEmpty,
    async loadBanks (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id
      }

      this.banks.loading = true
      try {
        const response = await this.$api.get(`/v1/financial/balance-accounts`, params)
        this.banks.data = response.filter(x => x.kind === 'bank')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.banks.loading = false
    },
    async loadBankAccounts (params = null) {
      params = params || {
        credentialId: this.banks.data.find(item => item._id === this.bank).credentialId
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/banks/accounts`, params)
        this.accounts = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async loadBankTransactions (params = null) {
      params = {
        bank: this.bank,
        accountId: this.account || undefined,
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.page - 1)),
        ...params
      }
      if (this.dates.length === 2) {
        const dates = [this.dates[0], this.dates[1]].sort((a, b) => {
          if (a > b) return 1
          if (a < b) return -1
          return 0
        })
        params.startDate = this.$moment(dates[0]).startOf('day').toISOString()
        params.endDate = this.$moment(dates[1]).endOf('day').toISOString()
        this.datePicker = false
      }
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/banks/transactions`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      if (this.bank) {
        await this.loadBankTransactions({
          bank: this.bank,
          accountId: this.account || undefined,
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1)),
          sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`
        })
      }
    },
    async resetDate () {
      this.dates = []
      this.datePicker = false
      await this.loadBankTransactions()
    },
    allowedDates (val) {
      return this.$moment(val).isSameOrBefore(new Date())
    },
    handleBankChange: async function () {
      this.account = null
      this.accounts.data = []
      this.table.data = []
      this.table.total = 0

      if (this.hasFinerioAccount) {
        await this.loadBankAccounts()
      } else {
        await this.loadBankTransactions()
      }
    },
    handleAccountChange: async function () {
      this.table.data = []
      this.table.total = 0
      await this.loadBankTransactions()
    },
    resetForm () {
      this.table.data = []
      this.table.total = 0
      this.bank = null
      this.account = null
      this.accounts.data = []
      this.accounts.loading = false
      this.banks.loading = false
      this.banks.data = []
      this.datePicker = false
      this.dates = []
    }
  }
}
</script>

<style lang="scss" scoped>
  .link:hover {
    text-decoration: underline;
    color: #3366BB !important;
  }

  .calendarTextField {
    height: 34px;
    width: 240px;
    border-radius: 22px;

    & ::v-deep .v-label {
      top: auto;
    }
  }

  .dateButton {
    text-transform: none;
  }
</style>
